import { dia, ui } from '@joint/plus';
import { columns, tasks as defaultTasks, dependencies as defaultDependencies } from './kanban/data';
import { Kanban } from './kanban/kanban';
import { Task as TaskShape, Header as HeaderShape, Dependency as DependencyShape, AnimatedElementView, cellNamespace } from './shapes';
var STORAGE_KEY = 'joint.kanban.board';
export var init = function () {
    var graph = new dia.Graph({}, { cellNamespace: cellNamespace });
    var paper = new dia.Paper({
        el: document.getElementById('paper'),
        width: 1000,
        height: 800,
        model: graph,
        background: { color: '#F3F7F6' },
        moveThreshold: 10,
        clickThreshold: 10,
        async: true,
        autoFreeze: true,
        frozen: true,
        viewManagement: {
            disposeHidden: true,
        },
        cellViewNamespace: cellNamespace,
        elementView: function (element) {
            if (TaskShape.isTask(element)) {
                return AnimatedElementView;
            }
            else {
                return dia.ElementView;
            }
        },
        interactive: false,
        preventDefaultBlankAction: false,
        defaultConnector: {
            name: 'curve',
            args: {
                distanceCoefficient: 0.2
            }
        },
        highlighting: {
            connecting: {
                name: 'addClass',
                options: {
                    className: 'highlighter-connection'
                }
            }
        },
        labelsLayer: true,
        linkPinning: false,
        multiLinks: false,
        validateConnection: function (sourceView, _, targetView) {
            var source = sourceView.model;
            var target = targetView.model;
            if (source === target)
                return false;
            if (!TaskShape.isTask(source))
                return false;
            if (!TaskShape.isTask(target))
                return false;
            return true;
        },
        defaultConnectionPoint: { name: 'anchor' },
        defaultAnchor: function (elementView, _magnet, _ref, _opt) {
            var link = this.model;
            var element = elementView.model;
            var source = link.getSourceElement();
            var target = link.getTargetElement();
            if (!source || !target)
                return element.getBBox().rightMiddle();
            var sourceStack = source.get('stackIndex');
            var targetStack = target.get('stackIndex');
            var offset = 30;
            if (sourceStack === targetStack) {
                return element.getBBox().rightMiddle();
            }
            else if (sourceStack > targetStack) {
                if (source === element) {
                    return element.getBBox().leftMiddle().offset(0, offset);
                }
                return element.getBBox().rightMiddle().offset(0, -offset);
            }
            else {
                if (source === element) {
                    return element.getBBox().rightMiddle().offset(0, -offset);
                }
                return element.getBBox().leftMiddle().offset(0, offset);
            }
        },
        defaultLink: function () {
            return new DependencyShape();
        }
    });
    var tasks;
    var dependencies;
    var cmdBuffer;
    var showDependencyTool = true;
    var savedBoardString = localStorage.getItem(STORAGE_KEY);
    if (savedBoardString) {
        try {
            var savedBoard = JSON.parse(savedBoardString);
            tasks = savedBoard.tasks;
            dependencies = savedBoard.dependencies;
            cmdBuffer = savedBoard.cmdBuffer;
            showDependencyTool = savedBoard.showDependencyTool;
        }
        catch (_a) {
            localStorage.removeItem(STORAGE_KEY);
        }
    }
    var kanban = new Kanban({
        paper: paper,
        topLeft: {
            x: 20,
            y: 50
        },
        tasks: tasks || defaultTasks,
        columns: columns,
        dependencies: dependencies || defaultDependencies,
        showDependencyTool: showDependencyTool
    });
    paper.unfreeze({
        cellVisibility: function (cell) {
            return kanban.showDependencyTool ? true : cell.isElement();
        }
    });
    var cmd = new dia.CommandManager({
        graph: graph,
        stackLimit: 20,
        cmdBeforeAdd: function (_cmdName, cell, _graph, options) {
            if (options === void 0) { options = {}; }
            if (HeaderShape.isHeader(cell))
                return false;
            return !options.ignoreCommandManager;
        }
    });
    if (cmdBuffer) {
        cmd.fromJSON(cmdBuffer);
    }
    cmd.on('stack:undo stack:redo', function () { return kanban.layoutView.model.update(); });
    cmd.on('stack', function () { return save(); });
    var toolbar = new ui.Toolbar({
        el: document.getElementById('toolbar'),
        tools: [
            'undo',
            'redo',
            {
                name: 'dependencies',
                type: 'checkbox',
                label: 'Dependencies',
                value: kanban.showDependencyTool
            }
        ],
        autoToggle: true,
        references: { commandManager: cmd }
    });
    toolbar.on('dependencies:change', function (enabled) {
        kanban.showDependencyTool = enabled;
        kanban.unselectTask();
        // Re-run the `cellVisibility` check to update the visibility of dependencies
        paper.wakeUp();
        save();
    });
    toolbar.render();
    function save() {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
            tasks: kanban.tasks,
            dependencies: kanban.dependencies,
            showDependencyTool: kanban.showDependencyTool,
            cmdBuffer: cmd.toJSON()
        }));
    }
};
